<mat-accordion>
    <mat-expansion-panel [expanded]="panelOpenState">
        <mat-expansion-panel-header>
            <mat-panel-title> {{ 'aumico_admin_translations_notes_types' | i18next }} </mat-panel-title>
            <mat-icon class="icon" svgIcon="aumico-pattern-icon-check-circle" *ngIf="isAllCompleted"></mat-icon>
            <mat-icon class="icon" svgIcon="aumico-pattern-icon-wrong-circle" *ngIf="!isAllCompleted"></mat-icon>
        </mat-expansion-panel-header>
        <mat-accordion [multi]="true">
            <div *ngFor="let notesType of notesTypesTranslationsList; index as i">
                <mat-expansion-panel [expanded]="panelOpenState">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ notesType.name }}</mat-panel-title>
                        <mat-icon
                            class="icon"
                            svgIcon="aumico-pattern-icon-check-circle"
                            *ngIf="isCompletedArray[i]"
                        ></mat-icon>
                        <mat-icon
                            class="icon"
                            svgIcon="aumico-pattern-icon-wrong-circle"
                            *ngIf="!isCompletedArray[i]"
                        ></mat-icon>
                    </mat-expansion-panel-header>
                    <aumico-notes-edit-notes-type-translations
                        [notesType]="notesType"
                        [currentLocale]="currentLocale"
                        [selectedLocale]="selectedLocale"
                        [panelOpenState]="panelOpenState"
                        (translationValuesChanged)="onNotesTypeTranslationsValuesChanged($event)"
                    ></aumico-notes-edit-notes-type-translations>
                </mat-expansion-panel>
            </div>
        </mat-accordion>
    </mat-expansion-panel>
</mat-accordion>
